import { createClient, groq } from 'next-sanity'

import { page, siteSettings } from '@/data/sanity/fragments'
import { basicProductFields, pageMetadataFields } from '@/data/sanity/fragments/_shared'
import { formatPageSections, formatSiteSettingsResponse, mergeSiteSettings } from '@/utils'

import { DOC_TYPES } from '@/data'

const perspective = process.env.SANITY_PREVIEW_TOKEN ? 'previewDrafts' : 'published'

// const useCdn = process.env.SANITY_PREVIEW_TOKEN === undefined ? true : false,
// We use this because revalidate on prod is around a week
// and whenever anything is saved/updated, it invalidates all paths
const useCdn = false

const SANITY_CONFIG = {
  projectId: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID,
  dataset: process.env.NEXT_PUBLIC_SANITY_DATASET,
  apiVersion: process.env.NEXT_PUBLIC_SANITY_API_VERSION,
  useCdn,
  token: process.env.SANITY_PREVIEW_TOKEN,
  perspective: perspective,
}

export const staticClient = createClient(SANITY_CONFIG)

export const getClient = () => {
  const config = {
    ...SANITY_CONFIG,
  }

  return createClient(config)
}

export const getSiteSettings = async isPreview => {
  const client = getClient()
  /* eslint-disable */
  const siteSettingsData = await client.fetch(
    `
      *[(
        _type == "siteSettingsMetadata" ||
        _type == "navigation" 
        )] {
        ${siteSettings.fields}
      }
  `,
    { isPreview: Boolean(isPreview) },
  )

  /* eslint-enable */

  if (!siteSettingsData?.length) return null

  const formatted = formatSiteSettingsResponse(siteSettingsData)

  return formatted
}

export const getPage = async (slug, type = 'page', isPreview) => {
  const client = getClient()
  const response = (
    await client.fetch(
      groq`
      *[_type == "${type}" && slug.current == "${slug}"] {
        ${page.getFields(true)},
        _type == "product" => {
            "nextProduct": *[_type == "product" && _createdAt < ^._createdAt && _id != ^._id] | order(_createdAt desc)[0] {
             ${basicProductFields}
            },
            "fallbackProduct": *[_type == "product" && _id != ^._id] | order(_createdAt desc)[0] {
              ${basicProductFields}
            }
        }
      }
  `,
      { isPreview: Boolean(isPreview) },
    )
  )[0]

  const siteSettings = await getSiteSettings(isPreview)

  if (!response || !siteSettings) return null

  const merged = mergeSiteSettings(response, siteSettings)

  // Get "next product" page
  if (merged?._type === DOC_TYPES.PRODUCT) {
    if (!merged?.nextProduct && merged?.fallbackProduct) {
      merged.nextProduct = merged.fallbackProduct
    }
  }

  const formatted = formatPageSections(merged)

  return formatted
}

export const getAllPages = async (type = 'page', isPreview) => {
  const client = getClient()
  const pages = await client.fetch(
    `
    *[_type == "${type}"] {
      ${pageMetadataFields}
    }
  `,
    { isPreview: Boolean(isPreview) },
  )

  if (!pages.length) return null

  return pages
}
